import Meta from 'src/components/meta/Meta';

const PreOrderSuccessMeta = () => <Meta
  title="Successful Preorder | Property Investment | BrickX"
/>;

export default PreOrderSuccessMeta;
